// import { useLazyGetWidgetInstanceQuery } from "@src/services/rollingStartApi";
import React, { Suspense } from "react";
import WidgetNotFound from "./WidgetNotFound/WidgetNotFound";
import { clsx } from "clsx";
import {
  WidgetComponentName,
  widgetComponents,
} from "@src/components/widgets/components";

import { ILoadWidgetProps } from "./WidgetInstance.interface";
import useWidgetInstanceVisibility from "./useWidgetInstanceVisibility";

const WidgetInstance = (props: ILoadWidgetProps) => {
  const { componentName, id_widget_instance, params, className } = props;

  const { canShowWidget } = useWidgetInstanceVisibility(params as any);

  // const [getWidgetInstance, { data: fetchedData }] =
  //   useLazyGetWidgetInstanceQuery();
  // const updatedParams =
  //   fetchedData && fetchedData.params ? fetchedData.params : params;
  const updatedParams = params;
  const template = updatedParams
    ? updatedParams.template || props.template || "default"
    : "default";
  const WidgetComponent =
    widgetComponents[componentName as WidgetComponentName] || WidgetNotFound;

  // chargement à chaud des données des widgets
  // useEffect(() => {
  //   // TODO: to check in production
  //   if (id_widget_instance) {
  //     getWidgetInstance(id_widget_instance);
  //   }
  // }, [getWidgetInstance, id_widget_instance]);
  // const inDom = (
  //   <div
  //     style={{
  //       position: "absolute",
  //       display: "block",
  //       background: "rgba(255,0,0,.5)",
  //       zIndex: 1000,
  //       fontFamily: "monospace",
  //     }}
  //   >{`${componentName}:${id_widget_instance}`}</div>
  // );

  if (!canShowWidget) {
    return null;
  }
  return (
    <div
      className={clsx(["widget-instance", className])}
      data-id_widget_instance={id_widget_instance}
      data-widget={componentName}
      data-template={template}
    >
      <Suspense fallback={<div></div>}>
        {/* @ts-ignore */}
        <WidgetComponent
          {...{
            ...props,
            template: template,
            params: updatedParams,
          }}
        />
      </Suspense>
    </div>
  );
};

export default WidgetInstance;
